import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import {
  ArtsInstructionIcon,
  PuzzleCircleIcon,
  StarCircleIcon,
  LikeCircleIcon,
  BrushCircleIcon,
  CalculatorCircleIcon,
  FocusCircleIcon,
  LeafHandCircleIcon,
  ThreeStickCircleIcon,
  StickCircleIcon,
  SocialEmotionalIcon,
  ThreeDotCircleIcon,
  NoneSquareIcon,
} from 'components/icons/basic'

const propTypes = {
  approachName: PropTypes.string.isRequired,
}

const defaultProps = {}

const approachIcons = {
  [Types.APPROACH_TYPES.ARTS_INSTRUCTION]: <ArtsInstructionIcon />,
  [Types.APPROACH_TYPES.ARTS_INTEGRATION]: <PuzzleCircleIcon />,
  [Types.APPROACH_TYPES.ARTS_EXPERIENCES]: <StarCircleIcon />,
  [Types.APPROACH_TYPES.ARTS_ENGAGEMENT]: <LikeCircleIcon />,
  [Types.APPROACH_TYPES.AESTHETIC_EDUCATION]: <BrushCircleIcon />,
  [Types.APPROACH_TYPES.STEAM]: <CalculatorCircleIcon />,
  [Types.APPROACH_TYPES.SINGLE_DISCIPLINE_ARTS_INSTRUCTION]: (
    <FocusCircleIcon />
  ),
  [Types.APPROACH_TYPES.ARTS_ENHANCEMENT]: <LeafHandCircleIcon />,
  [Types.APPROACH_TYPES.NON_ARTS_ENHANCEMENT]: <LeafHandCircleIcon />,
  [Types.APPROACH_TYPES.SEQUENTIAL_ARTS_INSTRUCTION]: <ThreeStickCircleIcon />,
  [Types.APPROACH_TYPES.NON_SEQUENTIAL_ARTS_INSTRUCTION]: <StickCircleIcon />,
  [Types.APPROACH_TYPES.SOCIAL_EMOTIONAL_LEARNING]: <SocialEmotionalIcon />,
  [Types.APPROACH_TYPES.OTHER]: <ThreeDotCircleIcon />,
  [Types.APPROACH_TYPES.NONE]: <NoneSquareIcon />,
}

function ApproachesTabCardIcon({ approachName }) {
  return approachIcons[approachName] || null
}

ApproachesTabCardIcon.propTypes = exact(propTypes)
ApproachesTabCardIcon.defaultProps = defaultProps

export default pure(ApproachesTabCardIcon)
